import { Button } from "@aws-amplify/ui-react";
import Tippy from '@tippyjs/react';
import * as Icons from "@mui/icons-material";

const ActionIcon = ({
  name,
  icon,
  color,
  onClick,
  showName = false,
  isSelected = false,
  isLoading = false,
}) => {
  const IconComponent = Icons[icon || "Bolt"];
  return (
    <Tippy content={name}>
      <Button
        isLoading={isLoading}
        className="px-1"
        variation="link"
        backgroundColor={isSelected && "overlay.20"}
        size="small"
        style={{ verticalAlign: "bottom" }}
        color={color}
        onClick={onClick}
      >
        <IconComponent />
        {showName && <>&nbsp;{name}</>}
      </Button>
    </Tippy>
  );
};

export default ActionIcon;
